import { pagesConfig } from '../../../shared/pages-config';
import SimpleBreadcrumbsPage from '../../../shared/simple-breadcrumbs-page';
import Box from '@mui/material/Box';
import { CLOUD_INSIGHTS_BREADCRUMBS } from './cloud-insights-utils';

export default function AssetDiscoveryPage() {
  const BREADCRUMBS = [
    ...CLOUD_INSIGHTS_BREADCRUMBS,
    { label: pagesConfig.insightsAssetDiscovery.name },
  ];

  return (
    <SimpleBreadcrumbsPage breadcrumbs={BREADCRUMBS} shouldAllowHeightToScroll>
      <Box p={1}></Box>
    </SimpleBreadcrumbsPage>
  );
}
